import { render, staticRenderFns } from "./WikiInvite.vue?vue&type=template&id=91c9a512"
import script from "./WikiInvite.vue?vue&type=script&lang=ts"
export * from "./WikiInvite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports